import { Component, OnInit } from '@angular/core';
import { label } from '../constants/labels';
import { message } from '../constants/messages';
import { TranslateService } from '@ngx-translate/core';
import { IDeviceGroup } from '@app/Models/IDeviceGroup';
import { MessageService } from 'primeng/api';
import { BaseAPIService } from '@app/Services/api.base.service';
import { ValidateRulesService } from '@app/shared/validate-rules.service';
import { Observable } from 'rxjs';
import { IGridCols } from '../Models/IGridCols';
import { IDeviceList, IDropdownConfig } from '../Models/IDeviceMetadata';
import { IIdNameValue } from '../Models/IDescValue';


@Component({
  selector: 'app-device-groups',
  standalone: false,
  templateUrl: './device-groups.component.html',
  styleUrls: ['./device-groups.component.scss'],
  providers: [MessageService]
})
export class DeviceGroupsComponent implements OnInit {

  groupsCols: Array<IGridCols>;
  groupInfoCols: Array<IGridCols>;
  labels: any;
  messages: any;
  deviceGroups: IDeviceGroup[];
  currentGroup: IDeviceGroup;
  newDeviceGroup: IDeviceGroup = { id: null, name: '', desc: '', deviceIds: [] };
  deviceGroupInfo: Array<IDeviceList>;
  isPagination: boolean = false;
  isGrpInfoPagination: boolean = false;
  noDataGroupInfo: boolean = false;
  noDataGroups: boolean = false;
  showInfoDialog: boolean = false;
  showAddEditDialog: boolean = false;
  showDeleteModal: boolean = false;
  isLoading: boolean = false;
  formInvalid: boolean = true;
  isEdit: boolean = false;
  addEditModalHeader: string;
  txtGroupName: string;
  txtGroupDesc: string;
  deviceDetails: Array<IIdNameValue> = [];
  selectDevicesConfig: IDropdownConfig;

  selectedDevices: Array<any> = [];
  groupNameValErrMsg: string = '';
  selectDevicesErrValMsg: string = '';

  constructor(
    private readonly baseService: BaseAPIService,
    private readonly translate: TranslateService,
    private readonly messageService: MessageService,
    private readonly validationService: ValidateRulesService) { }

  ngOnInit(): void {
    this.isLoading = true;
    this.labels = label;
    this.messages = message;
    this.groupsCols = [
      { field: 'name', header: this.labels.dgTblHeaderGroupName },
      { field: 'desc', header: this.labels.dgTblHeaderDescription },
      { field: 'addedOn', header: this.labels.dgTblHeaderCreatedDate }
    ];

    this.groupInfoCols = [
      { field: 'name', header: this.labels.tableHeaderDevice },
      { field: 'lastConnectedOn', header: this.labels.tableHeaderLastConnect },
      { field: 'deviceStatus', header: this.labels.tableDataDeviceActive }
    ];

    this.GetGroups();

    this.GetDeviceListData()

    this.selectDevicesConfig = {
      displayKey: "name",
      search: true,
      height: '200px',
      placeholder: this.translate.instant(this.labels.dgCreateDeviceList)
    }
  }


  GetGroups() {
    const apiUrl = '/Group/GetGroups';
    this.baseService.GET(apiUrl)
      .subscribe((response: IDeviceGroup[]) => {
        if (response && response.length > 0) {
          this.isLoading = false;
          this.deviceGroups = response;
          this.isPagination = this.deviceGroups.length < 10 ? false : true;
        }
        else {
          this.deviceGroups = null;
          this.noDataGroups = true;
          this.isPagination = false;
          this.isLoading = false;
        }
      });
  }

  GetDeviceListData() {
    const apiUrl = '/DeviceDashboard/DeviceDetailForDashboard';
    this.baseService.GET(apiUrl, {})
      .subscribe((result: Array<IDeviceList>) => {
        if (result && result.length > 0) {
          result.forEach(item => {
            this.deviceDetails.push({
              name: item.name,
              id: item.id
            })
          })
        }
      });
  }

  private GetGroupInfo(groupId: number) {
    const apiUrl = `/group/GroupDeviceInfo/${groupId}`;
    this.baseService.GET(apiUrl)
      .subscribe((response: Array<IDeviceList>) => {
        if (response && response.length > 0) {
          this.isLoading = false;
          this.deviceGroupInfo = response;
          this.isGrpInfoPagination = this.deviceGroupInfo.length < 5 ? false : true;
        }
        else {
          this.deviceGroupInfo = null;
          this.noDataGroupInfo = true;
          this.isGrpInfoPagination = false;
          this.isLoading = false;
        }
      }, (error) => {
        if (error.error === this.messages.groupEditNoAccess) {
          this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.groupEditNoAccess), key: 'error' });
        }
        else {
          this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.groupFetchInfoError), key: 'error' });
        }

      })
  }

  ResetGroup() {
    this.newDeviceGroup = { id: null, name: '', desc: '', deviceIds: [] };
    this.txtGroupName = '';
    this.txtGroupDesc = '';
    this.selectedDevices = [];
    this.formInvalid = true;
  }

  //Events

  OnSaveOrEditGroup() {
    this.isLoading = true;
    const baseApi = '/group/';
    this.newDeviceGroup.name = this.txtGroupName;
    this.newDeviceGroup.desc = this.txtGroupDesc;
    this.newDeviceGroup.deviceIds = this.selectedDevices.map(x => x.id);
    let groupAddUpdate = new Observable<any>();

    groupAddUpdate = !this.isEdit ? this.baseService.PostWithHeaders(`${baseApi}CreateGroup`, {}, this.newDeviceGroup) : this.baseService.PutWithHeaders(`${baseApi}EditGroup`, {}, this.newDeviceGroup);

    groupAddUpdate.subscribe((response) => {
      this.showAddEditDialog = false;
      if (response === null || response > 0) {
        if (!this.isEdit) {
          this.messageService.add({ severity: 'success', summary: this.translate.instant(this.messages.success), detail: `${this.newDeviceGroup.name} ${this.translate.instant(this.messages.createGroupSuccess)}`, key: 'success' });
        } else {
          this.messageService.add({ severity: 'success', summary: this.translate.instant(this.messages.success), detail: `${this.newDeviceGroup.name} ${this.translate.instant(this.messages.editGroupSuccess)}`, key: 'success' });
        }
        this.GetGroups();
        this.isLoading = false;
      }
      else {
        this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.createEditGroupFailure), key: 'error' });
      }
    }, (error) => {
      this.isLoading = false;
      this.showAddEditDialog = false;
      switch (error.error) {
        case this.messages.groupExists:
          this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.groupExists), key: 'error' });
          break;
        case this.messages.groupModelNotValid:
          this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.groupModelNotValid), key: 'error' });
          break;
        case this.messages.groupNameDescNotValid:
          this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.groupNameDescNotValid), key: 'error' });
          break;
        case this.messages.groupDeviceNotValid:
          this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.groupDeviceNotValid), key: 'error' });
          break;
        case this.messages.groupEditNoAccess:
          this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.groupEditNoAccess), key: 'error' });
          break;
        case this.messages.groupExistEdit:
          this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.groupExistEdit), key: 'error' });
          break;
        default:
          this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.createEditGroupFailure), key: 'error' });
          break;
      }
    });
  }

  OnAddGroup() {
    this.ResetGroup();
    this.isEdit = false;
    this.addEditModalHeader = label.dgCreateAddgroupDetails;
    this.showAddEditDialog = true;
  }

  OnEditGroup(rowData: IDeviceGroup) {
    this.isEdit = true;
    this.formInvalid = true;
    this.addEditModalHeader = label.dgEditAddgroupDetails;
    this.txtGroupName = rowData.name;
    this.txtGroupDesc = rowData.desc;
    this.newDeviceGroup.id = rowData.id;
    this.selectedDevices = this.deviceDetails.filter(item => rowData.deviceIds.includes(item.id));
    this.showAddEditDialog = true;
  }

  OnCancelAddEdit() {
    this.showAddEditDialog = false;
  }

  OnShowGroupInfo(rowData: IDeviceGroup) {
    this.isLoading = true;
    this.currentGroup = rowData;
    this.GetGroupInfo(this.currentGroup.id);
    this.deviceGroupInfo = null;
    this.showInfoDialog = true;
  }

  OnCloseGroupInfo() {
    this.showInfoDialog = false;
  }

  OnDeleteGroup(rowData: IDeviceGroup) {
    this.currentGroup = rowData;
    this.showDeleteModal = true;
  }

  OnGroupDeleteConfirm() {
    this.isLoading = true;
    this.showDeleteModal = false;
    const apiUrl = `/group/DeleteGroup/${this.currentGroup.id}`;
    this.baseService.DELETE(apiUrl)
      .subscribe((response: boolean) => {

        if (response === true) {
          this.GetGroups();
          this.isLoading = false;
          this.messageService.add({ severity: 'success', summary: this.translate.instant(this.messages.success), detail: `${this.currentGroup.name} ${this.translate.instant(this.messages.deleteGroupSuccess)}`, key: 'success' });
        }
        else {
          this.isLoading = false;
          this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.deleteGroupFailure), key: 'error' });
        }
      }, (error) => {
        this.isLoading = false;
        this.messageService.add({ severity: 'error', summary: this.translate.instant(this.messages.error), detail: this.translate.instant(this.messages.deleteGroupFailure), key: 'error' });
      });
  }

  OnGroupDeleteReject() {
    this.showDeleteModal = false;
  }

  onRejectToast() {
    this.messageService.clear('c');
  }

  ValidateForm() {
    this.groupNameValErrMsg = this.validationService.requiredElement(this.txtGroupName, 'Group Name', 0, 50);
    this.selectDevicesErrValMsg = this.validationService.requiredOneSelectedItem(this.selectedDevices, 'device');
    this.formInvalid = (this.selectDevicesErrValMsg === '' && this.groupNameValErrMsg === '') ? false : true;
  }


}
